import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function GujanMestras() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Gujan-Mestras | PVC Alu Bois | Baies Vitrées";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Gujan-Mestras ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Gujan-Mestras, fenêtres PVC Gujan, baies vitrées Gujan-Mestras, vitrier Gujan-Mestras');
    }

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '44.6333;-1.0667');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '44.6333;-1.0667';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Gujan-Mestras, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Gujan-Mestras, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Gujan-Mestras" />
      <Hero city="Gujan-Mestras" />
      <Services city="Gujan-Mestras" />
      <BayWindows city="Gujan-Mestras" />
      <WhatsAppDiagnostic city="Gujan-Mestras" />
      <Contact city="Gujan-Mestras" />
      <Footer city="Gujan-Mestras" />
    </div>
  );
}